import React from 'react'
import T from 'prop-types'
import { Button } from '@wework/dieter-ui'
import { LeftArrow, RightArrow } from '../Icons'
import IMTheme from '../../style/IMTheme'

class SwitchFloorButton extends React.PureComponent {
  state = {
    NextFloorDisabled: false,
    PrevFloorDisabled: false,
  }

  gridItemStyle = { paddingLeft: '0px', paddingRight: '0px' }

  componentDidMount() {
    this.checkNavigatorState(this.getCurrentFloorIndex(), this.props.floors)
  }

  componentWillReceiveProps(nextProps) {
    this.checkNavigatorState(
      this.getCurrentFloorIndex(nextProps),
      nextProps.floors
    )
  }

  checkNavigatorState = (index, floors) => {
    // check whether user is able to switch next/previous floor or not
    const NextFloorDisabled = this.checkFloorAvailability(index + 1, floors)
    const PrevFloorDisabled = this.checkFloorAvailability(index - 1, floors)

    this.setState({ NextFloorDisabled, PrevFloorDisabled })
  }

  getCurrentFloorIndex = (nextProps = '') => {
    let props = { ...this.props }
    if (nextProps) {
      props = { ...nextProps }
    }
    const { floors, currentFloor } = props

    if (!floors) {
      return undefined
    }

    let index = 0
    floors.forEach((floor, i) => {
      if (floor.uuid === currentFloor.uuid) {
        index = i
      }
    })

    return index
  }

  checkFloorAvailability = (floorIndex, floors) => {
    if (floors[floorIndex]) {
      return false
    }
    return true
  }

  switchFloor = (toNextFloor = true) => {
    const { floors, onChangeFloor } = this.props

    // get the current index of this floor in the array
    const result = this.getCurrentFloorIndex()

    // change the floor
    if (toNextFloor) {
      onChangeFloor(floors[result + 1])
    } else {
      onChangeFloor(floors[result - 1])
    }
  }

  render() {
    const { disabled } = this.props
    const { NextFloorDisabled, PrevFloorDisabled } = this.state

    return (
      <div
        style={{
          marginLeft: IMTheme.spacing[1],
          marginRight: IMTheme.spacing[1],
        }}
      >
        <Button
          onClick={() => {
            this.switchFloor(false)
          }}
          style={{
            margin: 0,
            borderTopRightRadius: 0,
            borderBottomRightRadius: 0,
            borderRight: 0,
          }}
          disabled={disabled || PrevFloorDisabled}
          icon={<LeftArrow />}
          basic
        />
        <Button
          onClick={() => {
            this.switchFloor(true)
          }}
          style={{
            margin: 0,
            borderTopLeftRadius: 0,
            borderBottomLeftRadius: 0,
          }}
          disabled={disabled || NextFloorDisabled}
          icon={<RightArrow />}
          basic
        />
      </div>
    )
  }
}

SwitchFloorButton.propTypes = {
  floors: T.array.isRequired,
  currentFloor: T.object,
  onChangeFloor: T.func,
  disabled: T.bool,
}

SwitchFloorButton.defaultProps = {
  currentFloor: {
    uuid: '',
    name: '',
  },
  onChangeFloor: () => {},
  disabled: false,
}

export default SwitchFloorButton
